import { ReactNode } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { DIALOG_BACKDROP, DIALOG_PANEL } from "./tableStyles";

type Props = {
  open: boolean;
  title: string;
  children?: ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel = "Delete",
  danger = true,
  busy = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Dialog open={open} onClose={onCancel} className="relative z-50">
      <DialogBackdrop transition className={DIALOG_BACKDROP} />
      <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
          <DialogPanel transition className={DIALOG_PANEL}>
            <div className="py-4 flex justify-between text-xl items-center">
              <h3 className="font-semibold opacity-70">{title}</h3>
              <button className="text-red-400" onClick={onCancel}>
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="p-5 border-y border-gray-500/50 text-sm space-y-4">
              {children}
            </div>
            <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                disabled={busy || confirmDisabled}
                onClick={onConfirm}
                className={
                  "inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-32 disabled:opacity-40 " +
                  (danger
                    ? "bg-red-600 hover:bg-red-500"
                    : "bg-indigo-500 hover:bg-indigo-400")
                }
              >
                {busy ? "..." : confirmLabel}
              </button>
              <button
                type="button"
                data-autofocus
                onClick={onCancel}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-slate-500/20 px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset ring-slate-500/40 hover:bg-slate-500/30 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
